import React, { Component } from 'react';
import { connect } from 'react-redux';
import Ajax from "Pub/js/ajax";
import platform from "Pub/js/platform";
import { langCheck, DeferFn, debounce } from "Pub/js/utils";
import { createTree } from 'Pub/js/createTree.js';
import DraggableTreeNode from './DraggableTreeNode';
import { setMetaTreeNodes } from "Store/ZoneSetting/action";
import DragPreview from './DragPreview';
import NotHaveMetaData from './NotHaveMetaData';
import _ from 'lodash';
import { Select, Input } from 'antd';
import { queryMetaTreeData, asyncQueryMetaPro, createMetaTreeIns, appendMetaTreeNodes, queryMetaPropByKeyWords } from '../../metatree/MetaTreeTools';
import MetaTreeModel from '../../metatree/MetaTreeModel';
const Search = Input.Search;

const Option = Select.Option;
const { NCTree, NCIcon, NCCheckbox, NCFormControl } = platform.base;
const TreeNode = NCTree.NCTreeNode;
const getParentKey = (item, tree) => {
    let parentKey;
    const { key } = item;
    for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.children) {
            if (node.children.some(item => item.key.indexOf(key) > -1)) {
                parentKey = node.key;
            } else if (getParentKey(key, node.children)) {
                parentKey = getParentKey(key, node.children);
            }
        }
    }
    return parentKey;
};
class LeftSideMetaTree extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedKeys: [],
            needToBeAllSelectNodeList: [],
            expandedKeys: [],
            checkAllTree: false,
            searchValue: '',
            searchSelectedKeys: [],
            searchTreeData: [],
            searchExpandedKeys: [],
            // origTree: null,
            curTree: null,
        };
    }
    componentDidMount() {
        let { selectedArea, origTree } = this.props;
        let { metaid } = selectedArea;
        // console.log(metaid);
        // queryMetaTreeData.call(this, metaid, '').then((data) => {
        //     let treeData = { isleaf: false, readonly: false, refpk: metaid, refcode: '', pid: null, children: data };
        //     let tree = createMetaTreeIns(treeData);
        //     this.setState({
        //         origTree: tree,
        //         curTree: tree
        //     });
        // });
        this.setState({ curTree: origTree });

    }

    componentWillReceiveProps(nextProps, nextContext) {
        let { currentArea, metaTreeNodes } = this.props;

        //清空上一次所选的值
        if (currentArea.pk_area !== nextProps.currentArea.pk_area) {
            this.setState({
                curTree: nextProps.origTree,
                selectedKeys: [],
                searchSelectedKeys: [],
                expandedKeys: [],
                needToBeAllSelectNodeList: [],
                checkAllTree: false,
                searchValue: '',
                searchTreeData: [],
            });
            this.props.setMetaTreeNodes([]);
        }

        //元数据拖放到区域
        if (nextProps.metaTreeNodes.length === 0 && metaTreeNodes.length > 0) {
            this.setState({
                selectedKeys: [],
                searchSelectedKeys: [],
                needToBeAllSelectNodeList: [],
                checkAllTree: false,
            });
        }
    }

	createCodeObject = () => {
	    let { areaList, targetAreaID } = this.props;
	    let codeObj = {};
	    let areaItem = areaList.find(item => item && item.pk_area === targetAreaID);
	    let queryPropertyList = areaItem && areaItem.queryPropertyList;
	    queryPropertyList && queryPropertyList.forEach(item => {
	        codeObj[item.proid] = item.proid;
	    });
	    return codeObj;
	};

	// renderTreeNodes = data => {
	// 	let { expandedKeys, searchValue } = this.state;
	// 	let { targetAreaID, metaTreeNodes, currentArea } = this.props;
	// 	let codeObject = this.createCodeObject();

	// 	return data.map(item => {
	// 		const fieldidClassName = `fieldid_${item.refcode}_node`; //自动化测试标记
	// 		const movedItem = codeObject[item.proid] ? 'moved-tree-node' : '';
	// 		const index = item.title.search(searchValue);
	// 		const beforeStr = item.title.substr(0, index);
	// 		const afterStr = item.title.substr(index + searchValue.length);
	// 		const title = index > -1 ? (
	// 			<span>
	// 				{beforeStr}
	// 				<span className="u-tree-searchable-filter">{searchValue}</span>
	// 				{afterStr}
	// 			</span>
	// 		) : (
	// 			<span>{item.title}</span>
	// 		);
	// 		item.targetAreaID = targetAreaID;
	// 		if (item.children) {
	// 			return (
	// 				<TreeNode
	// 					key={item.key}
	// 					dataRef={item}
	// 					className={`${fieldidClassName} ${movedItem}`}
	// 					icon={<span className={`icon iconfont ${expandedKeys.includes(item.refcode)
	// 						? 'icon-wenjianjiadakai'
	// 						: 'icon-wenjianjia'}`
	// 					}/>}
	// 					title={<DraggableTreeNode
	// 						title={title}
	// 						dataRef={item}
	// 						targetAreaID={targetAreaID}
	// 						selectedNodes={metaTreeNodes}
	// 						movedItem={!!movedItem}
	// 						initState={this.initState}
	// 						currentArea={currentArea}
	// 					/>}
	// 				>
	// 					{this.renderTreeNodes(item.children)}

	// 				</TreeNode>

	// 			);
	// 		}
	// 		if (item.isleaf) {
	// 			return (<TreeNode
	// 				{...item}
	// 				dataRef={item}
	// 				className={`${fieldidClassName} ${movedItem}`}
	// 				title={<DraggableTreeNode
	// 					title={title}
	// 					dataRef={item}
	// 					targetAreaID={targetAreaID}
	// 					selectedNodes={metaTreeNodes}
	// 					movedItem={!!movedItem}
	// 					initState={this.initState}
	// 					currentArea={currentArea}
	// 				/>}
	// 			/>);
	// 		} else {
	// 			return (
	// 				<TreeNode
	// 					{...item}
	// 					dataRef={item}
	// 					className={`${fieldidClassName} ${movedItem}`}
	// 					icon={<span className={`icon iconfont ${expandedKeys.includes(item.refcode)
	// 						? 'icon-wenjianjiadakai'
	// 						: 'icon-wenjianjia'}`
	// 					}/>}
	// 					title={<DraggableTreeNode
	// 						title={title}
	// 						dataRef={item}
	// 						targetAreaID={targetAreaID}
	// 						selectedNodes={metaTreeNodes}
	// 						movedItem={!!movedItem}
	// 						initState={this.initState}
	// 						currentArea={currentArea}
	// 					/>}
	// 				/>
	// 			);
	// 		}
	// 	});
	// };

	// onLoadData = (treeNode) => {
	// 	let { json } = this.props;
	// 	return new Promise(resolve => {
	// 		if (treeNode.props.children) {
	// 			resolve();
	// 			return;
	// 		}
	// 		Ajax({
	// 			url: `/nccloud/platform/templet/querymetapro.do`,
	// 			info: {
	// 				name: langCheck(
	// 					"ZoneSetting-000017",
	// 					"pages",
	// 					json
	// 				) /* 国际化处理： 单据模板设置*/,
	// 				action: langCheck(
	// 					"ZoneSetting-000020",
	// 					"pages",
	// 					json
	// 				) /* 国际化处理： 元数据树结构查询*/
	// 			},
	// 			data: {
	// 				// metaid: metaid
	// 				metaid: treeNode.props.refpk
	// 			},
	// 			success: res => {
	// 				if (res) {
	// 					let { data, success } = res.data;
	// 					if (
	// 						success &&
	// 						data &&
	// 						data.rows &&
	// 						data.rows.length > 0
	// 					) {
	// 						let metaTree = [];
	// 						data.rows.map((r, index) => {
	// 							let tmpMetaTree = {
	// 								...r,
	// 								title: `${r.refcode} ${r.refname}`,
	// 								key: `${treeNode.props.myUniqID}.${
	// 									r.refcode
	// 									}`,
	// 								myUniqID: `${treeNode.props.myUniqID}.${
	// 									r.refcode
	// 									}`,
	// 								isLeaf: r.isleaf
	// 							};
	// 							//非查询区域的子表里的code不是全路径
	// 							if (
	// 								this.props.targetAreaType !== "0" &&
	// 								treeNode.props.notSearchAreaCode
	// 							) {
	// 								tmpMetaTree.notSearchAreaCode = `${
	// 									treeNode.props.notSearchAreaCode
	// 									}.${r.refcode}`;
	// 							}
	// 							//非查询区域的子表的code，若父级是205则直接为自身refcode
	// 							if (
	// 								this.props.targetAreaType !== "0" &&
	// 								treeNode.props.datatype === "205"
	// 							) {
	// 								tmpMetaTree.notSearchAreaCode = `${
	// 									r.refcode
	// 									}`;
	// 							}
	// 							metaTree.push(tmpMetaTree);
	// 						});
	// 						treeNode.props.dataRef.children = [].concat(
	// 							metaTree
	// 						);
	// 						this.props.updateMetaTreeData([
	// 							...this.props.metaTree
	// 						]);
	// 						resolve();
	// 					}
	// 				}
	// 			}
	// 		});
	// 	});
	// };

	// onSelect = (selectedKeys, info) => {
	// 	this.setState({
	// 		selectedKeys: selectedKeys,
	// 		searchSelectedKeys: selectedKeys
	// 	});

	// 	let slimSelectedNodes = info.selectedNodes.map(item => {
	// 		return { props: { dataRef: item.props.dataRef } }
	// 	});

	// 	this.props.setMetaTreeNodes(slimSelectedNodes)
	// };

	selectAllTreeNode = (isChecked, metaTreeNodeList) => {
	    let { selectedKeys } = this.state;
	    let codeObject = this.createCodeObject();
	    selectedKeys = _.cloneDeep(selectedKeys);
	    let selectedNodes = this.props.metaTreeNodes;
	    if (isChecked) {
	        //循环遍历树结构，只选中非205的数据类型
	        _.forEach(metaTreeNodeList, (m, i) => {
	            if (
	                selectedKeys.indexOf(m.myUniqID) === -1 &&
					codeObject[m.proid] === undefined &&
					m.datatype !== "205"
	            ) {
	                selectedKeys.push(m.myUniqID);
	                selectedNodes.push({ props: { dataRef: { ...m } } });
	            }
	        });
	    } else {
	        _.forEach(metaTreeNodeList, (m, i) => {
	            _.remove(selectedKeys, n => {
	                return n === m.myUniqID;
	            });
	        });
	        _.forEach(metaTreeNodeList, (m, i) => {
	            _.remove(selectedNodes, n => {
	                return n.props.dataRef.myUniqID === m.myUniqID;
	            });
	        });
	    }
	    this.setState({
	        selectedKeys,
	        checkAllTree: isChecked,
	    });
	    this.props.setMetaTreeNodes(selectedNodes);
	};

	handleChangeSelectTreeNode = value => {
	    const { canSelectTreeNodeList } = this.props;
	    //循环遍历204类型的节点
	    _.forEach(canSelectTreeNodeList, m => {
	        if (value.indexOf(`${m.refcode} ${m.refname}`) === -1) {
	            if (m.children !== null) {
	                setTimeout(() => {
	                    this.selectAllTreeNode(false, m.children);
	                }, 0);
	            }
	        } else {
	            if (m.children !== null) {
	                setTimeout(() => {
	                    this.selectAllTreeNode(true, m.children);
	                }, 0);
	            }
	        }
	    });
	    this.setState({ needToBeAllSelectNodeList: value });
	};

	initState = () => {
	    this.setState({
	        selectedKeys: [],
	        searchSelectedKeys: [],
	        checkAllTree: false,
	    });
	    this.props.setMetaTreeNodes([]);
	};

	handleSearch = value => {
	    let { searchTreeData, searchSelectedKeys } = this.state;
	    let searchExpandedKeys = [];
	    DeferFn(() => {
	        Ajax({
	            url: '/nccloud/platform/templet/searchmeta.do',
	            data: {
	                metaid: this.props.selectedArea.metaid,
	                text: value,
	            },
	            info: {
	                name: langCheck(
	                    "ZoneSetting-000017",
	                    "pages",
	                    this.props.json,
	                ) /* 国际化处理： 单据模板设置*/,
	                action: langCheck(
	                    "ZoneSetting-000020",
	                    "pages",
	                    this.props.json,
	                ), /* 国际化处理： 元数据树结构查询*/
	            },
	            success: ({ data: { data } }) => {
	                if (data) {
	                    let metaTree = [];
	                    //元数据树最外层树结构的拼接
	                    data.map(r => {
	                        metaTree.push({
	                            ...r,
	                            title: `${r.refcode} ${r.refname}`,
	                            key: `${r.refcode}`,
	                            myUniqID: `${r.refcode}`,
	                            isLeaf: r.isleaf,
	                        });
	                    });
	                    metaTree.forEach(item => {
	                        if (item.title.indexOf(value) > -1) {
	                            const parentKey = getParentKey(item, data);
	                            if(parentKey && !searchExpandedKeys.includes(parentKey)) {
	                                searchExpandedKeys.push(parentKey);
	                            }
	                            if(parentKey) {
	                                console.log(parentKey);
	                            }
	                        }
	                    });

	                    this.setState({
	                        searchExpandedKeys,
	                        searchSelectedKeys,
	                        searchTreeData: metaTree,
	                    });
	                } else {
	                    this.setState({
	                        searchExpandedKeys: [],
	                        searchSelectedKeys: [],
	                        searchTreeData: [],
	                    });
	                }
	            },
	        });
	    });
	}
    /**
     * 关键词搜索改变
     * @param {String} value 搜索框当前的字符串
     */
    onSearchFieldChange = debounce(value => {
        let { origTree, searchField } = this.props;
        if (value.length === 0) {
            this.setState({
                searchValue: value,
                searchExpandedKeys: [],
                curTree: origTree,
            });
        } else {
            this.setState({ searchValue: value });
        }
    }, 300)
    /**
     * 关键字搜索
     * @param {String} value 关键字
     */
    onSearchMeta = value => {
        // 发送搜索请求，对返回结果进行树实例化，并渲染节点树
        if (!value) {
            return;
        }
        let { selectedArea, origTree } = this.props;
        let metaid = selectedArea.metaid;
        let { searchTreeData, searchSelectedKeys } = this.state;
        let searchExpandedKeys = [];
        let nextTree = queryMetaPropByKeyWords.call(this, value, origTree, searchExpandedKeys);
        let resultTreeData = nextTree.getMetaTreeData();
        let metaTree = resultTreeData.children;
        if (nextTree.getRoot().children.length > 0) {
            this.setState({
                curTree: nextTree,
                searchExpandedKeys,
                searchSelectedKeys,
                searchTreeData: metaTree,
            });
        } else {
            this.setState({
                curTree: nextTree,
                searchExpandedKeys: [],
                searchSelectedKeys: [],
                searchTreeData: [],
            });
        }
    }
    onSearchMetaAsync = value => {
        let { selectedArea, currentArea } = this.props;
        let { metaid } = selectedArea;
        if (!value) {
            return;
        }
        DeferFn(() => {
            queryMetaTreeData.call(this, metaid, value).then(data => {
                let treeData = { isleaf: false, readonly: false, refpk: currentArea.metaid, refcode: '', pid: null, children: data };
                let tree = createMetaTreeIns.call(this, treeData, currentArea.areatype);
                let resultTreeData = tree.getMetaTreeData();
                let metaTree = resultTreeData.children;
                console.log(resultTreeData);
            });
        });
    }
    /**
     * 关键字搜索框清空事件
     */
    onSearchFieldClean = () => {
        // TODO 需要恢复上一次元数据树的状态，并同步选中节点
        let { origTree, searchField } = this.props;
        ReactDOM.findDOMNode(searchField).querySelector('.ant-input').value = '';
        this.setState({
            searchValue: '',
            curTree: origTree,
        });

    }
    //渲染元数据树 type search:搜索之后展示的树
    // renderTree = (type = 'default') => {
    // 	let { expandedKeys, selectedKeys } = this.state;
    // 	let treeData = this.props.metaTree;
    // 	const handleExpand = (expandedKeys) => {
    // 		if(type === 'search') {
    // 			this.setState({ searchExpandedKeys: expandedKeys });
    // 		} else {
    // 			this.setState({ expandedKeys });
    // 		}
    // 	}
    // 	if(type === 'search') {
    // 		selectedKeys = this.state.searchSelectedKeys;
    // 		expandedKeys = this.state.searchExpandedKeys;
    // 		treeData = this.state.searchTreeData;
    // 	}

    // 	// const newTreeData = [{
    // 	// 	refcode: '00',
    // 	// 	refname: '元数据',
    // 	// 	title: '',
    // 	// 	children: createTree(treeData, 'key', 'pid')
    // 	// }]
    // 	// const newTreeData = createTree(treeData, 'key', 'pid')
    // 	return (
    // 		<NCTree
    // 			showIcon
    // 			checkStrictly={true}
    // 			loadData={this.onLoadData}
    // 			showLine={true}
    // 			multiple={true}
    // 			onSelect={this.onSelect}
    // 			onExpand={handleExpand}
    // 			expandedKeys={expandedKeys}
    // 			selectedKeys={selectedKeys}
    // 			fieldid="meta"
    // 		>
    // 			{this.renderTreeNodes(treeData)}
    // 		</NCTree>
    // 	)
    // }
    /**
     * 异步加载树节点
     * @param {Object} treeNode 树节点
     */
    onLoadSubTreeData = treeNode => {
        let { searchValue, curTree } = this.state;
        let { targetAreaType, origTree } = this.props;
        let { children, refpk, myUniqID, notSearchAreaCode, datatype, dataRef } = treeNode.props;
        let searchExpandedKeys = [];
        return new Promise(resolve => {
            if (children) {
                resolve();
                return;
            }
            asyncQueryMetaPro.call(this, refpk).then(data => {
                let tree = origTree,
                    nextTree = [];
                if (searchValue) {
                    nextTree = appendMetaTreeNodes.call(this, data.rows, myUniqID, curTree);
                    // nextTree = queryMetaPropByKeyWords.call(this, searchValue, selectTree, searchExpandedKeys);
                } else {
                    tree = appendMetaTreeNodes.call(this, data.rows, myUniqID, origTree);
                    nextTree = queryMetaPropByKeyWords.call(this, searchValue, tree, searchExpandedKeys);
                }
                this.setState({
                    // origTree: tree,
                    curTree: nextTree,
                    // searchExpandedKeys
                });

                let metaTreeRootData = tree.getMetaTreeData();
                // this.props.updateMetaTreeData(metaTreeRootData.children);
                this.props.updateMetaTreeData({
                    metaTree: metaTreeRootData.children,
                    origTree: tree,
                });
                resolve();
            });
        });
    }
    /**
     * 树节点选择
     * @param {Array} selectedKeys
     * @param {Object} info
     */
    onSelectTreeNode = (selectedKeys, info) => {
        this.setState({
            selectedKeys,
            searchSelectedKeys: selectedKeys,
        });
        let slimSelectedNodes = info.selectedNodes.map(item => {
            return { props: { dataRef: item.props.dataRef } };
        });
        this.props.setMetaTreeNodes(slimSelectedNodes);
    }
    /**
     * 展开节点
     * @param {Array} expandedKeys
     * @param {Object} item 节点状态
     * @param {String} type
     */
    onExpandTreeNode = (expandedKeys, item, type) => {
        let { expanded, node } = item;
        let myUniqID = _.result(node, 'props.dataRef.myUniqID');
        if (expanded === false) {
            expandedKeys = _.filter(expandedKeys, el => el.indexOf(myUniqID) === -1);
        }
        if (type === 'search') {
            this.setState({ searchExpandedKeys: expandedKeys });
        } else {
            this.setState({ expandedKeys });
        }
    }
    /**
     * 渲染元数据树
     * @param {String} type [default|search]
     */
    renderMetaTree = (type = 'default') => {
        let { expandedKeys, selectedKeys, searchSelectedKeys, searchExpandedKeys } = this.state;
        if (type === 'search') {
            selectedKeys = searchSelectedKeys;
            expandedKeys = searchExpandedKeys;
        }
        return (
            <NCTree
                fieldid="meta"
                showIcon
                // checkStrictly={true}
                mustExpandable={true}
                showLine={true}
                multiple={true}
                loadData={this.onLoadSubTreeData}
                onSelect={this.onSelectTreeNode}
                onExpand={(expandedKeys, item) => {this.onExpandTreeNode(expandedKeys, item, type);}}
                expandedKeys={expandedKeys}
                selectedKeys={selectedKeys}
            >
                {this.renderMetaTreeNodes(type)}
            </NCTree>
        );
    }
    /**
     * 渲染树单个节点
     */
    renderTreeNode = (node, map, type) => {
        let { expandedKeys, searchExpandedKeys, searchValue } = this.state;
        let curExpandedKeys = type === 'search' ? searchExpandedKeys : expandedKeys;
        let { targetAreaID, metaTreeNodes, currentArea } = this.props;
        let codeObject = this.createCodeObject();
        let { data, parent, children } = node;
        // let { isLeaf, key, refcode, title, proid } = data;
        let { children:childrenInfo, ...item } = data;
        let { isLeaf, key, refcode, title, proid } = item;
        // 自动化测试标记
        const fieldidClassName = `fieldid_${refcode}_node`;
        const movedItem = codeObject[proid] ? 'moved-tree-node' : '';
        const index = title.search(searchValue);
        const beforeStr = title.substr(0, index);
        const afterStr = title.substr(index + searchValue.length);
        let titleEl = index > -1 ? (
            <span>
                {beforeStr}
                <span className="wui-tree-searchable-filter">{searchValue}</span>
                {afterStr}
            </span>
        ) : (
            <span>{title}</span>
        );
        let iconEl = (
            <span className={`icon iconfont ${curExpandedKeys.includes(refcode)
                ? 'icon-wenjianjiadakai' : 'icon-wenjianjia'}`
            }/>
        );
        let draggableTreeNodeEl = (
            <DraggableTreeNode
                title={titleEl}
                dataRef={item}
                targetAreaID={targetAreaID}
                selectedNodes={metaTreeNodes}
                movedItem={!!movedItem}
                initState={this.initState}
                currentArea={currentArea}
            />
        );
        item.targetAreaID = targetAreaID;
        let el;
        if (children.length > 0) {
            let childrenEls = children.map(childNode => {
                let el = map.get(childNode);
                return el;
            });
            el = React.createElement(TreeNode, {
                ...item,
                key: key,
                dataRef: item,
                className:  `${fieldidClassName} ${movedItem}`,
                icon: iconEl,
                title: draggableTreeNodeEl,
            }, childrenEls);
        } else {
            if (isLeaf) {
                el = (
                    <TreeNode
                        { ...item }
                        dataRef={item}
                        className={ `${fieldidClassName} ${movedItem}` }
                        title={draggableTreeNodeEl}
                    />
                );
            } else {
                el = (
                    <TreeNode
                        {...item}
                        dataRef={item}
                        className={ `${fieldidClassName} ${movedItem}` }
                        icon={iconEl}
                        title={draggableTreeNodeEl}
                    />
                );
            }
        }
        return el;
    }
    /**
     * 渲染元数据树的节点
     */
    renderMetaTreeNodes = type => {
        let { curTree } = this.state;
        if (!(curTree instanceof MetaTreeModel)) {
            return null;
        }
        // console.time('SerializeMetaTreeNodes');
        let serializeTree = MetaTreeModel.serialize(curTree);
        // console.timeEnd('SerializeMetaTreeNodes');
        // console.time(`RenderMetaTreeNodes`);
        let reverseNodes = serializeTree.nodes.reverse();
        let root = curTree.getRoot();
        let map = new Map();
        reverseNodes.forEach(node => {
            let el = this.renderTreeNode(node, map, type);
            map.set(node, el);
        });
        let ret = root.children.map(node => {
            return map.get(node);
        });
        // console.timeEnd(`RenderMetaTreeNodes`);
        return ret;
    }
    render() {
        let { json, canSelectTreeNodeList, metaTree } = this.props;
        let { searchValue } = this.state;

        return (
            <div className='left-side-meta-tree'>
                <div className='tree-feature-container'>
                    <div className="tip">
                        <i className="iconfont icon-zhuyi1" />
                        {/* 国际化处理： 请点击/拖拽以下区域至右侧页面 */}
                        {langCheck('ZoneSetting-000197', 'pages', json)}
                    </div>
                    {/* <div className="metatree-search-input">
						<Search
							value={this.state.searchValue}
							placeholder={langCheck('ZoneSetting-000322', 'pages', json)} //国际化处理： 搜索
							onChange={this.handleSearchChange}
							onSearch={this.handleSearch}
						/>
						{this.state.searchValue && <i class="icon iconfont icon-qingkong" onClick={() => this.setState({ searchValue: '' })}></i>}
					</div> */}
                    <div className="metatree-search-input" style={{ width: '250px', display: 'block' }}>
                        <Search
                            ref={el => this.props.searchField = el}
                            // value={searchValue}
                            // 国际化处理： 搜索
                            placeholder={langCheck('ZoneSetting-000322', 'pages', json)}
                            onChange={e => {
                                this.onSearchFieldChange(e.target.value);
                            }}
                            onSearch={this.onSearchMeta}
                            suffix={ <i className="icon iconfont icon-sousuo st-icon-sousuo" onClick={this.onSearchMeta} />}
                            // onSearch={this.onSearchMetaAsync}
                        />
                        {this.state.searchValue && <i className="icon iconfont icon-qingkong" onClick={this.onSearchFieldClean}></i>}
                    </div>
                    <NCCheckbox
                        className="dnd-cancel check-all-tree" //必须加。不加的话不能触发click事件
                        onChange={val => {
                            this.selectAllTreeNode(
                                val,
                                this.props.metaTree,
                            );
                        }}
                        checked={this.state.checkAllTree}
                    >
                        {langCheck("ZoneSetting-000125", "pages", json)}
                        {/* /* 国际化处理： 全选根节点*/}
                    </NCCheckbox>

                    {/* {
						canSelectTreeNodeList.length > 0
						&& <div fieldid="root" className='left-tree-search'>
							<Select
								className="dnd-cancel" //必须加。不加的话不能触发click事件
								maxTagCount={1}
								size="small"
								style={{ width: "212px" }}
								multiple={true}
								mode="multiple"
								placeholder={langCheck(
									"ZoneSetting-000126",
									"pages",
									json
								)} 
								onChange={this.handleChangeSelectTreeNode}
								value={this.state.needToBeAllSelectNodeList}
								dropdownClassName="fieldid_root_select"
								notFoundContent={langCheck("ZoneSetting-000277",
									"pages",
									json)}
							>
								{this.props.canSelectTreeNodeList.map(
									(node, index) => {
										return (
											<Option
												key={`${node.refcode} ${
													node.refname
													}`}
												disabled={
													node.children ? false : true
												}
											>
												{node.refcode} {node.refname}
											</Option>
										);
									}
								)}
							</Select>
						</div>
					} */}
                </div>
                <div className="tree-contianer"
                    // style={{ height: canSelectTreeNodeList.length > 0 ? 'calc(100% - 133px)' : 'calc(100% - 81px)' }}
                >
                    {
                        metaTree.length > 0
                            ? this.renderMetaTree(this.state.searchValue ? 'search' : 'default')
                            : <NotHaveMetaData text={langCheck('ZoneSetting-000278', 'pages', json)} />
                    }
                </div>

                <DragPreview />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        metaTreeNodes: state.zoneSettingData.metaTreeNodes,
        areaList: state.zoneSettingData.areaList,
        selectedArea: state.zoneSettingData.selectedArea,
    };
}

export default connect(
    mapStateToProps,
    { setMetaTreeNodes },
)(LeftSideMetaTree);
